import { render, staticRenderFns } from "./project-budget.vue?vue&type=template&id=c2f1d910&scoped=true"
import script from "./project-budget.vue?vue&type=script&setup=true&lang=js"
export * from "./project-budget.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f1d910",
  null
  
)

export default component.exports